import { handleTooltip } from './tooltipCommands';
export var handleLinkAccountTooltip = function handleLinkAccountTooltip(actionCommand, props) {
  var text = actionCommand.tooltip.text;
  var details = {
    title: text,
    animationState: 'AnimationFadeIn',
    style: {
      top: '12vh',
      left: window.innerWidth >= 1920 ? '70%' : window.innerWidth >= 1700 ? '72vw' : '75vw',
      zIndex: '9999',
      display: 'flex',
      alignItems: 'center',
      fontWeight: '700',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    displayTextStyle: {
      fontSize: '17px',
      fontStyle: 'italic',
      flex: 1,
      textAlign: 'center',
      margin: '5px'
    },
    arrowStyle: {
      left: '2vw'
    },
    innerStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };
  handleTooltip(details, props, actionCommand);
};
export var handleRewardCenterTooltip = function handleRewardCenterTooltip(actionCommand, props) {
  var text = actionCommand.tooltip.text;
  var details = {
    title: text,
    animationState: 'AnimationFadeIn',
    style: {
      top: '70vh',
      left: '52.5vw',
      zIndex: '9999',
      display: 'flex',
      alignItems: 'center',
      fontWeight: '700',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    displayTextStyle: {
      fontSize: '17px',
      fontStyle: 'italic',
      flex: 1,
      textAlign: 'center',
      margin: '5px'
    },
    arrowStyle: {
      position: 'absolute',
      top: '78px',
      transform: 'rotate(180deg)',
      flex: '0',
      width: '5rem',
      height: '5rem'
    },
    innerStyle: {
      display: 'flex',
      alignItems: 'center'
    }
  };
  handleTooltip(details, props, actionCommand);
};